import { useEffect, useState, type ReactNode } from 'react';
import { Loading } from '@/components/common';
import { isLocalSession, localAuth } from '@/services/localAuth';
import { useAuthStore } from '@/stores';

export function LocalSessionGuard({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(() => !isLocalSession());
  useEffect(() => {
    if (!isLocalSession()) return;
    let active = true;
    localAuth.getCurrentUser()
      .then(user => { if (active) useAuthStore.getState().setUser(user); })
      .catch(() => { if (active) useAuthStore.getState().logout(); })
      .finally(() => { if (active) setReady(true); });
    return () => { active = false; };
  }, []);
  return ready ? children : <Loading size="lg" text="验证中..." />;
}
